/* Sleepgram bundle builder v1 */
(function () {
  'use strict';

  var BEDS = ['Twin', 'Twin XL', 'Full', 'Queen', 'King', 'Cal King'];
  var HEX = {
    'Slate Grey': '#ACA9AC', 'Sand': '#ddd0bd', 'White': '#e0e1e6', 'Light Grey': '#d8d2d0', 'Oat': '#e8e0d6',
    'Champagne': '#D3A186', 'Pink': '#E8CFD3', 'Sage Green': '#AAAD9A', 'Grey Stripe': '#808080',
    'Violet': '#d6b4fc', 'Poseidon Blue': '#768c99', 'Ivory': '#FFFFF0', 'Rosé': '#FFC5CB', 'Platinum': '#E5E4E2'
  };
  var PAIR = { 'Light Grey': 'Slate Grey', 'Oat': 'Sand', 'Champagne': 'Sand', 'Pink': 'White', 'Sage Green': 'White' };
  /* bedroom scene images in Content > Files, named {sheet}_{duvet}.jpg, e.g. slate_grey_white.jpg */
  var SCENE_EXT = '.png';
  var SCENE_NAME = { 'Grey Stripe': 'grey_strip' };
  var SHEETS = ['sleepgram-bamboo-sheets', 'cotton-sheets'];
  var FABRIC = {
    'sleepgram-bamboo-sheets': { label: 'Organic Bamboo', sub: 'Silky, cool to the touch' },
    'cotton-sheets': { label: 'Supima Cotton', sub: 'Crisp, silver-infused' }
  };
  var SHORT = {
    'sleepgram-bamboo-sheets': 'Bamboo Sheet Set', 'cotton-sheets': 'Supima Cotton Sheet Set',
    'supima-cotton-duvet-cover': 'Supima Cotton Duvet Cover', 'sleepgram-comforter': 'Down-Alternative Comforter',
    'sleepgram-pillow': '3-in-1 Adjustable Pillow', 'sleepgram-silk-pillowcase': 'Silk Pillowcases (2 pack)'
  };

  function duvetSize(b) { return (b === 'Twin' || b === 'Twin XL') ? 'Twin/Twin XL' : (b === 'Full' || b === 'Queen') ? 'Full/Queen' : 'King/Cal King'; }
  function pillowSize(b) { return (b === 'King' || b === 'Cal King') ? 'King' : 'Standard/Queen'; }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function refreshSliders(groups) {
    var $ = window.jQuery;
    groups.forEach(function (g) {
      if ($ && $.fn.slick) $(g).find('.slick-initialized').slick('setPosition');
      g.querySelectorAll('.swiper, .swiper-container').forEach(function (el) { if (el.swiper) el.swiper.update(); });
      if (window.Flickity) g.querySelectorAll('.flickity-enabled').forEach(function (el) { var f = Flickity.data(el); if (f) f.resize(); });
    });
    window.dispatchEvent(new Event('resize'));
  }
  function img(src, w) { if (!src) return ''; src = src.indexOf('//') === 0 ? 'https:' + src : src; return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + (w || 800); }

  function Builder(root) {
    this.root = root;
    this.d = JSON.parse(root.querySelector('.sgb__data').textContent);
    /* coupon codes have no spaces; drop pasted invisible characters (nbsp, zero-width) */
    this.d.code = String(this.d.code || '').replace(/[\s ​-‍⁠﻿]/g, '').toUpperCase();
    this.P = this.d.products;
    this.type = this.d.type;
    this.fmt = this.d.moneyFormat || '${{amount}}';
    var s = {
      bed: 'Queen', fabric: 'sleepgram-bamboo-sheets', sheetColor: null, duvetMatch: true, duvetColor: null,
      weight: 'All-season', pack: '2 Pack', silkColor: null, pSize: 'Standard/Queen', view: null
    };
    this.s = s;
    if (this.type !== 'beauty') s.sheetColor = this.colors(s.fabric)[0];
    if (this.type === 'beauty') s.silkColor = this.colors('sleepgram-silk-pillowcase')[0];
    this.normalize(true);
    this.bind();
    this.render();
  }

  Builder.prototype.money = function (cents) {
    var n = (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return this.fmt.replace(/\{\{\s*\w+\s*\}\}/, n);
  };
  Builder.prototype.colors = function (h) {
    var p = this.P[h]; if (!p) return [];
    var i = p.options.indexOf('Color'); if (i < 0) return [];
    var out = [];
    p.variants.forEach(function (v) { if (out.indexOf(v.options[i]) < 0) out.push(v.options[i]); });
    return out;
  };
  Builder.prototype.variant = function (h, sel) {
    var p = this.P[h]; if (!p) return null;
    return p.variants.find(function (v) {
      return p.options.every(function (name, i) { return sel[name] === undefined || v.options[i] === sel[name]; });
    }) || null;
  };
  Builder.prototype.ok = function (h, sel) { var v = this.variant(h, sel); return !!(v && v.available); };
  Builder.prototype.firstOk = function (h, list, make) {
    for (var i = 0; i < list.length; i++) { if (this.ok(h, make(list[i]))) return list[i]; }
    return null;
  };
  Builder.prototype.pSz = function () { return this.type === 'beauty' ? this.s.pSize : pillowSize(this.s.bed); };

  Builder.prototype.duvet = function () {
    var s = this.s, h = 'supima-cotton-duvet-cover', size = duvetSize(s.bed), cols = this.colors(h), self = this;
    var mk = function (c) { return { Size: size, Color: c }; };
    if (!s.duvetMatch) return { color: s.duvetColor, note: 'Pick any color, or tick the box to coordinate automatically.' };
    var direct = cols.indexOf(s.sheetColor) > -1;
    var target = direct ? s.sheetColor : (PAIR[s.sheetColor] || 'White');
    if (!this.ok(h, mk(target))) {
      var alt = this.firstOk(h, cols, mk) || target;
      return { color: alt, note: target + ' is sold out in ' + size + ', so we paired ' + alt + ' instead.' };
    }
    return { color: target, note: direct ? 'Matches your ' + s.sheetColor + ' sheets.' : s.sheetColor + ' isn’t made as a duvet, so we paired ' + target + ', our closest match.' };
  };

  /* Keep every selection valid after a change; tell the shopper about any swap. */
  Builder.prototype.normalize = function (silent) {
    var s = this.s, msgs = [], self = this;
    if (this.type !== 'beauty') {
      var sh = s.fabric, cols = this.colors(sh);
      var mk = function (c) { return { Size: s.bed, Color: c }; };
      if (cols.indexOf(s.sheetColor) < 0 || !this.ok(sh, mk(s.sheetColor))) {
        var c = this.firstOk(sh, cols, mk);
        if (c && c !== s.sheetColor) { if (s.sheetColor && cols.indexOf(s.sheetColor) > -1) msgs.push(s.sheetColor + ' sheets are sold out in ' + s.bed + ', switched to ' + c + '.'); s.sheetColor = c; }
      }
    }
    if (this.type === 'full') {
      var ds = duvetSize(s.bed), dh = 'supima-cotton-duvet-cover';
      if (!s.duvetMatch && !this.ok(dh, { Size: ds, Color: s.duvetColor })) {
        var dc = this.firstOk(dh, this.colors(dh), function (c) { return { Size: ds, Color: c }; });
        if (dc) { msgs.push(s.duvetColor + ' duvet is sold out in ' + ds + ', switched to ' + dc + '.'); s.duvetColor = dc; }
      }
      var ch = 'sleepgram-comforter';
      if (!this.ok(ch, { Size: ds, Weight: s.weight })) {
        var other = s.weight === 'All-season' ? 'Lightweight' : 'All-season';
        if (this.ok(ch, { Size: ds, Weight: other })) { msgs.push(s.weight + ' comforter is sold out in ' + ds + ', switched to ' + other + '.'); s.weight = other; }
      }
    }
    if (this.type === 'beauty') {
      var silk = 'sleepgram-silk-pillowcase', ps = s.pSize;
      var mks = function (c) { return { Size: ps, Color: c, 'Pack Size': '2 Pack' }; };
      if (!this.ok(silk, mks(s.silkColor))) {
        var sc = this.firstOk(silk, this.colors(silk), mks);
        if (sc) { msgs.push(s.silkColor + ' silk is sold out in ' + ps + ', switched to ' + sc + '.'); s.silkColor = sc; }
      }
    }
    var pp = this.pSz();
    if (!this.ok('sleepgram-pillow', { Size: pp, 'Pack Size': s.pack })) {
      var alt = s.pack === '2 Pack' ? '1 Pack' : '2 Pack';
      if (this.ok('sleepgram-pillow', { Size: pp, 'Pack Size': alt })) { msgs.push(pp + ' pillows are sold out in the ' + s.pack.toLowerCase() + ', switched to ' + alt.toLowerCase() + '.'); s.pack = alt; }
    }
    if (!silent && msgs.length) this.toast(msgs.join(' '));
  };

  Builder.prototype.lines = function () {
    var s = this.s, L = [], self = this, ds = duvetSize(s.bed), pp = this.pSz();
    function add(key, h, sel, detail, color) {
      var v = self.variant(h, sel);
      L.push({ key: key, h: h, v: v, name: SHORT[h], detail: detail, color: color,
        price: v ? v.price : 0, cmp: v ? (v.compare_at_price || v.price) : 0, ok: !!(v && v.available),
        img: v && v.featured_image ? v.featured_image.src : (self.P[h] && self.P[h].featured_image) });
    }
    if (this.type === 'beauty') {
      add('silk', 'sleepgram-silk-pillowcase', { Size: pp, Color: s.silkColor, 'Pack Size': '2 Pack' }, pp + ' · ' + s.silkColor, s.silkColor);
    } else {
      add('sheet', s.fabric, { Size: s.bed, Color: s.sheetColor }, s.bed + ' · ' + s.sheetColor, s.sheetColor);
    }
    if (this.type === 'full') {
      var du = this.duvet();
      add('duvet', 'supima-cotton-duvet-cover', { Size: ds, Color: du.color }, ds + ' · ' + du.color, du.color);
      add('comforter', 'sleepgram-comforter', { Size: ds, Weight: s.weight }, ds + ' · ' + s.weight, null);
    }
    add('pillow', 'sleepgram-pillow', { Size: pp, 'Pack Size': s.pack }, pp + ' · ' + s.pack, null);
    return L;
  };

  /* bedroom image for the chosen colors: Full Comfort {sheet}_{duvet}.png, Sleep Starter {sheet}.png */
  Builder.prototype.scene = function () {
    if ((this.type !== 'full' && this.type !== 'starter') || !this.d.files) return null;
    var sheet = this.s.sheetColor, name = function (c) { return SCENE_NAME[c] || c.toLowerCase().replace(/[^a-z0-9]+/g, '_').replace(/^_|_$/g, ''); };
    if (!sheet) return null;
    var src, detail;
    if (this.type === 'full') {
      var duvet = this.duvet().color;
      if (!duvet) return null;
      src = name(sheet) + '_' + name(duvet) + SCENE_EXT;
      detail = sheet + ' sheets · ' + duvet + ' duvet';
    } else {
      src = name(sheet) + SCENE_EXT;
      detail = sheet + ' sheets';
    }
    /* versioned URL from Liquid (?v= changes when the file is replaced), else the plain file URL */
    src = (this.d.scenes && this.d.scenes[src]) || this.d.files + src;
    if (this._missing && this._missing[src]) return null;
    return { key: 'scene', name: 'Your bedroom', detail: detail, img: src };
  };

  /* ---------- rendering ---------- */
  Builder.prototype.pill = function (label, pressed, act, val, disabled, extra) {
    return '<button type="button" class="sgb__pill' + (extra ? ' ' + extra : '') + '" aria-pressed="' + pressed + '" data-act="' + act + '" data-val="' + esc(val) + '"' + (disabled ? ' disabled' : '') + '>' + label + '</button>';
  };
  Builder.prototype.swatch = function (c, sel, act, out, size) {
    var bg = c === 'Grey Stripe' ? 'background-image:url(' + esc(this.d.stripe) + ');background-size:cover' : 'background-color:' + (HEX[c] || '#ccc');
    var lab = out ? c + ' (sold out in ' + size + ')' : c;
    return '<button type="button" class="sgb__sw' + (out ? ' is-out' : '') + '" style="' + bg + '" aria-label="' + esc(lab) + '" title="' + esc(lab) + '" aria-pressed="' + (c === sel) + '" data-act="' + act + '" data-val="' + esc(c) + '"' + (out ? ' disabled' : '') + '></button>';
  };
  Builder.prototype.step = function (n, title, note, body) {
    return '<fieldset class="sgb__step"><legend class="sgb__legend"><span class="sgb__num" aria-hidden="true">' + n + '</span>' + title + '</legend>' +
      (note ? '<p class="sgb__note">' + note + '</p>' : '') + body + '</fieldset>';
  };

  Builder.prototype.controls = function () {
    var s = this.s, self = this, H = '', n = 1, ds = duvetSize(s.bed), pp = this.pSz();
    if (this.type === 'beauty') {
      H += this.step(n++, 'Pillow size', 'Your silk pillowcases are cut to the same size automatically.',
        '<div class="sgb__row">' + ['Standard/Queen', 'King'].map(function (p) { return self.pill(esc(p), p === s.pSize, 'psize', p); }).join('') + '</div>');
      var sh = 'sleepgram-silk-pillowcase';
      H += this.step(n++, 'Silk pillowcases <span class="sgb__muted">(2 pack)</span>', '22 momme mulberry silk, ' + esc(pp) + '.',
        '<p class="sgb__label">Color: <strong>' + esc(s.silkColor) + '</strong></p><div class="sgb__row">' +
        this.colors(sh).map(function (c) { return self.swatch(c, s.silkColor, 'silk', !self.ok(sh, { Size: pp, Color: c, 'Pack Size': '2 Pack' }), pp); }).join('') + '</div>');
    } else {
      var map = this.type === 'full'
        ? [['Sheets', s.bed], ['Duvet & comforter', ds], ['Pillows', pp]]
        : [['Sheets', s.bed], ['Pillows', pp]];
      H += this.step(n++, 'Your bed size', 'Pick once and we size every item in the bundle to match.',
        '<div class="sgb__row">' + BEDS.map(function (b) { return self.pill(esc(b), b === s.bed, 'bed', b); }).join('') + '</div>' +
        '<p class="sgb__map">' + map.map(function (m) { return '<span><strong>' + esc(m[0]) + '</strong> → ' + esc(m[1]) + '</span>'; }).join('') + '</p>');

      var fab = SHEETS.filter(function (h) { return self.P[h]; }).map(function (h) {
        return self.pill('<strong>' + FABRIC[h].label + '</strong><span>' + FABRIC[h].sub + ' · ' + self.colors(h).length + ' colors</span>', h === s.fabric, 'fabric', h, false, 'sgb__pill--card');
      }).join('');
      var cols = this.colors(s.fabric), anyOut = false;
      var sw = cols.map(function (c) { var out = !self.ok(s.fabric, { Size: s.bed, Color: c }); anyOut = anyOut || out; return self.swatch(c, s.sheetColor, 'sheet', out, s.bed); }).join('');
      var cases = (s.bed === 'Twin' || s.bed === 'Twin XL') ? '1 pillowcase' : '2 pillowcases';
      H += this.step(n++, 'Sheet set', 'Fitted sheet, flat sheet and ' + cases + ', sized ' + esc(s.bed) + '.',
        '<div class="sgb__row">' + fab + '</div><p class="sgb__label">Color: <strong>' + esc(s.sheetColor) + '</strong></p><div class="sgb__row">' + sw + '</div>' +
        (anyOut ? '<p class="sgb__note">Crossed-out colors are sold out in ' + esc(s.bed) + '.</p>' : ''));

      if (this.type === 'full') {
        var du = this.duvet(), dh = 'supima-cotton-duvet-cover', ch = 'sleepgram-comforter';
        var dsw = this.colors(dh).map(function (c) { return self.swatch(c, du.color, 'duvet', !self.ok(dh, { Size: ds, Color: c }), ds); }).join('');
        var weights = [['All-season', 'Cozy, year-round warmth'], ['Lightweight', 'For hot sleepers & summer']].map(function (w) {
          var out = !self.ok(ch, { Size: ds, Weight: w[0] });
          return self.pill('<strong>' + w[0] + '</strong><span>' + (out ? 'Sold out in ' + esc(ds) : w[1]) + '</span>', w[0] === s.weight, 'weight', w[0], out, 'sgb__pill--card');
        }).join('');
        var comfOut = !this.ok(ch, { Size: ds, Weight: s.weight });
        H += this.step(n++, 'Duvet cover &amp; comforter', 'Both sized ' + esc(ds) + ' for your ' + esc(s.bed) + '.',
          '<label class="sgb__check"><input type="checkbox" data-act="match"' + (s.duvetMatch ? ' checked' : '') + '> Match duvet to my sheets</label>' +
          '<p class="sgb__note">' + esc(du.note) + '</p>' +
          '<p class="sgb__label">Duvet color: <strong>' + esc(du.color) + '</strong></p><div class="sgb__row">' + dsw + '</div>' +
          '<p class="sgb__label">Comforter weight</p><div class="sgb__row">' + weights + '</div>' +
          (comfOut ? '<p class="sgb__alert" role="alert">The comforter is sold out in ' + esc(ds) + ' right now. Choose a smaller bed size, or try the Sleep Starter Bundle.</p>' : ''));
      }
    }
    var packs = [['1 Pack', 'One pillow'], ['2 Pack', 'A pair, most popular']].map(function (p) {
      var v = self.variant('sleepgram-pillow', { Size: pp, 'Pack Size': p[0] });
      var out = !(v && v.available);
      return self.pill('<strong>' + p[0] + '</strong><span>' + (out ? 'Sold out in ' + esc(pp) : p[1] + (v ? ' · ' + self.money(v.price) : '')) + '</span>', p[0] === s.pack, 'pack', p[0], out, 'sgb__pill--card');
    }).join('');
    H += this.step(n++, '3-in-1 Adjustable Pillows', 'Sized ' + esc(pp) + (this.type === 'beauty' ? ' to match your pillowcases.' : ' for your ' + esc(s.bed) + ' bed.'),
      '<div class="sgb__row">' + packs + '</div>');
    return H;
  };

  Builder.prototype.render = function () {
    var self = this, s = this.s, root = this.root, L = this.lines();
    var focusKey = document.activeElement && root.contains(document.activeElement) && document.activeElement.dataset.act
      ? document.activeElement.dataset.act + '|' + document.activeElement.dataset.val : null;

    root.querySelector('.sgb__controls').innerHTML = this.controls();

    var sub = 0, cmp = 0, allOk = true;
    L.forEach(function (l) { sub += l.price; cmp += l.cmp; allOk = allOk && l.ok; });
    var pct = Math.max(0, Math.min(50, Number(this.d.discount) || 0));
    var disc = Math.round(sub * pct / 100), total = sub - disc, save = cmp - total;

    root.querySelector('.sgb__lines').innerHTML = L.map(function (l) {
      var dot = l.color ? '<span class="sgb__dot" style="' + (l.color === 'Grey Stripe' ? 'background-image:url(' + esc(self.d.stripe) + ');background-size:cover' : 'background:' + (HEX[l.color] || '#ccc')) + '" aria-hidden="true"></span>' : '<span class="sgb__dot sgb__dot--plain" aria-hidden="true"></span>';
      return '<li class="sgb__line' + (l.ok ? '' : ' is-out') + '">' + dot + '<span class="sgb__lname"><strong>' + esc(l.name) + '</strong><span>' + esc(l.detail) + (l.ok ? '' : ' · Sold out') + '</span></span>' +
        '<span class="sgb__lprice"><strong>' + self.money(l.price) + '</strong>' + (l.cmp > l.price ? '<s>' + self.money(l.cmp) + '</s>' : '') + '</span></li>';
    }).join('') + (pct ? '<li class="sgb__line sgb__line--disc"><span class="sgb__lname"><strong>Bundle discount (' + pct + '%)</strong></span><span class="sgb__lprice"><strong>−' + this.money(disc) + '</strong></span></li>' : '');

    root.querySelector('.sgb__totals').innerHTML =
      '<span class="sgb__total">' + this.money(total) + '</span>' + (cmp > total ? '<s class="sgb__cmp">' + this.money(cmp) + '</s><span class="sgb__save">Save ' + this.money(save) + ' (' + Math.round(save / cmp * 100) + '%)</span>' : '') +
      '<span class="sgb__count">' + L.length + ' products' + (this.type === 'beauty' ? '' : ', all sized for ' + esc(s.bed)) + '</span>';

    var btn = root.querySelector('.sgb__add');
    btn.disabled = !allOk;
    btn.textContent = allOk ? 'Add bundle to cart' : 'An item is sold out in this size';

    /* gallery: bedroom scene first, then each product; main image follows the item you last changed */
    var G = L.slice(), sc = this.scene();
    if (sc) G.unshift(sc);
    var viewLine = G.filter(function (l) { return l.key === s.view; })[0] || G[0];
    var main = root.querySelector('.sgb__main');
    if (viewLine && viewLine.img) { var src = img(viewLine.img, 1000); if (main.getAttribute('src') !== src) main.setAttribute('src', src); main.alt = viewLine.name + ', ' + viewLine.detail; }
    /* missing scene file: remember it and fall back to the product photos */
    main.onerror = function () {
      if (!sc || main.getAttribute('src') !== img(sc.img, 1000)) return;
      (self._missing = self._missing || {})[sc.img] = true;
      self.render();
    };
    root.querySelector('.sgb__thumbs').innerHTML = G.map(function (l) {
      return '<button type="button" class="sgb__thumb" data-act="view" data-val="' + l.key + '" aria-pressed="' + (l === viewLine) + '" aria-label="Show ' + esc(l.name) + '">' +
        (l.img ? '<img src="' + esc(img(l.img, 200)) + '" alt="" width="100" height="100" loading="lazy">' : '') + '</button>';
    }).join('');
    root.querySelector('.sgb__caption').textContent = viewLine ? viewLine.name + ' · ' + viewLine.detail : '';

    /* below-the-fold info follows the main item */
    var info = document.querySelector('[data-sgb-info="' + root.dataset.sgb + '"]');
    if (info) {
      var want = this.type === 'beauty' ? 'sleepgram-silk-pillowcase' : s.fabric;
      var shown = [];
      info.querySelectorAll('.sgb-info__group').forEach(function (g) {
        var hide = g.dataset.handle !== want;
        if (g.hidden && !hide) shown.push(g);
        g.hidden = hide;
      });
      /* sliders set up while their group was hidden measured 0px wide: re-measure once visible */
      if (shown.length) requestAnimationFrame(function () { refreshSliders(shown); });
    }

    if (focusKey) {
      var parts = focusKey.split('|');
      var el = root.querySelector('[data-act="' + parts[0] + '"][data-val="' + (window.CSS && CSS.escape ? CSS.escape(parts[1]) : parts[1]) + '"]');
      if (el) el.focus({ preventScroll: true });
    }
  };

  Builder.prototype.toast = function (msg) {
    var t = this.root.querySelector('.sgb__toast');
    t.textContent = msg; t.hidden = false;
    clearTimeout(this._t);
    this._t = setTimeout(function () { t.hidden = true; }, 4500);
  };

  /* ---------- events ---------- */
  Builder.prototype.bind = function () {
    var self = this;
    this.root.addEventListener('click', function (e) {
      var b = e.target.closest('[data-act]');
      if (!b || b.disabled || b.type === 'checkbox') return;
      var s = self.s, v = b.dataset.val;
      switch (b.dataset.act) {
        case 'bed': s.bed = v; break;
        case 'psize': s.pSize = v; break;
        case 'fabric': s.fabric = v; s.view = 'scene'; break;
        case 'sheet': s.sheetColor = v; s.view = 'scene'; break;
        case 'duvet': s.duvetMatch = false; s.duvetColor = v; s.view = 'scene'; break;
        case 'weight': s.weight = v; s.view = 'comforter'; break;
        case 'pack': s.pack = v; s.view = 'pillow'; break;
        case 'silk': s.silkColor = v; s.view = 'silk'; break;
        case 'view': s.view = v; self.render(); return;
        default: return;
      }
      self.normalize(false);
      self.render();
    });
    this.root.addEventListener('change', function (e) {
      if (e.target.dataset.act !== 'match') return;
      var s = self.s;
      s.duvetColor = self.duvet().color;
      s.duvetMatch = e.target.checked;
      s.view = 'scene';
      self.normalize(false);
      self.render();
    });
    this.root.querySelector('.sgb__add').addEventListener('click', function () { self.addToCart(this); });
  };

  Builder.prototype.addToCart = function (btn) {
    var self = this, L = this.lines();
    if (L.some(function (l) { return !l.ok; })) return;
    var bid = 'B' + Date.now().toString(36) + Math.random().toString(36).slice(2, 6);
    var pct = Math.max(0, Math.min(50, Number(this.d.discount) || 0));
    var items = L.map(function (l) {
      var props = { _bundle: self.d.title, _bundle_id: bid, _bundle_size: L.length };
      if (self.d.code) props._bundle_code = self.d.code;
      if (pct) props._bundle_discount = pct;
      return { id: l.v.id, quantity: 1, properties: props };
    });
    var msg = this.root.querySelector('.sgb__msg');
    btn.disabled = true; btn.textContent = 'Adding…'; msg.textContent = '';
    fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function () { return window.sgBundleGuard ? window.sgBundleGuard.sync() : null; })
      .then(function () {
        btn.textContent = 'Added to cart';
        msg.textContent = self.d.title + ' added to your cart.';
        self.openCart();
        setTimeout(function () { self.render(); }, 2500);
      })
      .catch(function (err) {
        btn.disabled = false; btn.textContent = 'Add bundle to cart';
        msg.textContent = (err && (err.description || err.message)) || 'Sorry, something went wrong. Please try again.';
      });
  };

  /* Same cart-drawer refresh the current theme uses, with fallbacks. */
  Builder.prototype.openCart = function () {
    var drawer = document.querySelector('cart-drawer');
    if (drawer && window.jQuery) {
      var $ = window.jQuery;
      $('cart-drawer').load(location.href + ' #CartDrawer', function (res, status) {
        if (status === 'success') {
          $('cart-drawer').removeClass('is-empty');
          $('.darwer__inner-empty').hide();
          if (drawer.open) drawer.open();
          $('cart-drawer').addClass('active');
        }
      });
      this.updateCount();
    } else {
      window.location.href = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart';
    }
  };

  /* Header cart count. The theme only renders .cart-count-bubble when the cart has items,
     so re-render the theme's cart-icon-bubble section; if it has none, build the bubble here. */
  Builder.prototype.updateCount = function () {
    var root = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/');
    var icons = document.querySelectorAll('#cart-icon-bubble');
    fetch(root + '?sections=cart-icon-bubble').then(function (r) { return r.json(); }).then(function (s) {
      if (!s['cart-icon-bubble'] || !icons.length) throw new Error('no cart-icon-bubble section');
      var tmp = document.createElement('div');
      tmp.innerHTML = s['cart-icon-bubble'];
      var html = (tmp.querySelector('.shopify-section') || tmp).innerHTML;
      icons.forEach(function (el) { el.innerHTML = html; });
    }).catch(function () {
      return fetch(root + 'cart.js').then(function (r) { return r.json(); }).then(function (c) {
        var n = c.item_count, label = n + (n === 1 ? ' item' : ' items');
        var links = icons.length ? icons : document.querySelectorAll('a[href$="/cart"]');
        links.forEach(function (link) {
          var b = link.querySelector('.cart-count-bubble');
          if (!n) { if (b) b.remove(); return; }
          if (!b) { b = document.createElement('div'); b.className = 'cart-count-bubble'; link.appendChild(b); }
          b.innerHTML = '<span aria-hidden="true">' + n + '</span><span class="visually-hidden">' + label + '</span>';
        });
      });
    });
  };

  function init() {
    document.querySelectorAll('[data-sgb]').forEach(function (root) {
      if (root.__sgb) return;
      try { root.__sgb = new Builder(root); } catch (e) { console.error('[sgb]', e); }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
